import path from 'path';

import {AppInterfaceErrorTypes, AppInterfaceErrorReasons, AppInterfaceError} from './app-interface-types';
import StringTool from '../../lib/tools/string-tool';

export class AppInterfaceHelper {

    constructor(verbose = true)   {
        this.verbose = verbose;
    }

    _resolveRejectResult(resolve, reject, result, resTransFn)  {
        if(result.isError())    {
            reject(this.printError(result.error));
            return;
        }
        resolve(resTransFn ? resTransFn(result) : result.result);
    }

    _resolveRejectResultPromise(result, resTransFn)  {
        if(result.isError())    return Promise.reject(this.printError(result.error));
        return Promise.resolve(resTransFn ? resTransFn(result) : result.result);
    }

    downloadFile(url)   {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onloadend = e => {
                if(xhr.status !== 200) {
                    reject(this.printError(new AppInterfaceError(
                        AppInterfaceErrorTypes.std,
                        AppInterfaceErrorReasons.couldNotDownloadFile,
                        url
                    )));
                    return;
                }
                let buffer = xhr.response;
                resolve({content: buffer, path: url});
            }
            xhr.send();
        });
    }

    downloadUILinkRef(oe, target, uiLinkRef, uiLinkRefPath = 'ui-states/')  {
        return new Promise((resolve, reject) => {
            if(!target) {
                if(!oe.isReady())  {
                    reject(this.printError(new AppInterfaceError(
                        AppInterfaceErrorTypes.std,
                        AppInterfaceErrorReasons.notReady
                    )));
                    return;
                }
                target = oe.sharedInterface.getUIControllerApp().getTarget();
            }

            let url = path.join('app/oe/', uiLinkRefPath, target + '_' + uiLinkRef);
            resolve(url);
        }).then(url => this.downloadFile(url)).then(res => new Promise((resolve, reject) => {
            let view = new Uint8Array(res.content);
            let str = StringTool.stringFromUTF8Array(view);
            resolve({link: str, path: res.path});
        }));
    }

    printError(error)   {
        if(!this.verbose || !error || !error.print)  return error;
        error.print();
        return error;
    }
}

export default new AppInterfaceHelper();